import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const atLeastOne = (validator: ValidatorFn, controls: string[] = null) => (form: FormGroup,): ValidationErrors | null => {
    if (!controls) {
        controls = Object.keys(form.controls)
    }

    const hasAtLeastOne = form && form.controls && controls.some(k => !validator(form.controls[k]));

    return hasAtLeastOne ? null : { atLeastOne: true };
};
